import React from "react"
import { VStack } from "@chakra-ui/react"
import { Control, useWatch } from "react-hook-form"
import { BadgeElementType, BadgeQRFormat } from "sharedTypes/badge"
import EditorPane from "components/CanvasEditor/EditorPane"
import PropertyRow from "components/CanvasEditor/Inspector/PropertyRow"
import NumberProperty from "components/CanvasEditor/Inspector/NumberProperty"
import { getQRCodeMinSize } from "components/BadgeBuilder/utils/badgeHelpers"
import { BadgeElementFormValues } from "components/BadgeBuilder/Panels/EditorPanel/BadgeSidePanelForm"

type Props = {
  control: Control<BadgeElementFormValues>
}

const PositionSizeFields = ({ control }: Props) => {
  const elementType = useWatch({ control, name: "selectedBlockType" })
  const format = useWatch({ control, name: "format" })

  const minSize = elementType === BadgeElementType.QR_CODE && format
    ? getQRCodeMinSize(format as BadgeQRFormat)
    : 1

  return (
    <EditorPane title="Layer">
      <VStack gap={2} alignItems="stretch">
        <PropertyRow label="Position" rightAlign>
          <NumberProperty
            label="X"
            name="x"
            control={control}
            min={0}
            step={1}
            precision={0}
            inlineLabel
            size="sm"
          />
          <NumberProperty
            label="Y"
            name="y"
            control={control}
            min={0}
            step={1}
            precision={0}
            inlineLabel
            size="sm"
          />
        </PropertyRow>
        <PropertyRow label="Size" rightAlign>
          <NumberProperty
            label="W"
            name="width"
            control={control}
            min={minSize}
            step={1}
            precision={0}
            size="sm"
            inlineLabel
          />
          <NumberProperty
            label="H"
            name="height"
            control={control}
            min={minSize}
            step={1}
            precision={0}
            size="sm"
            inlineLabel
          />
        </PropertyRow>
      </VStack>
    </EditorPane>
  )
}

export default PositionSizeFields
